/**
 * Reusable Hero Section component
 * Used by both pre-launch and landing pages
 */

import { cn } from "../../lib/utils";

interface HeroSectionProps {
  title: string;
  subtitle: string;
  titleClassName?: string;
  subtitleClassName?: string;
  containerClassName?: string;
}

export function HeroSection({
  title,
  subtitle,
  titleClassName,
  subtitleClassName,
  containerClassName,
}: HeroSectionProps) {
  return (
    <div className={cn("text-center max-w-4xl mx-auto px-4", containerClassName)}>
      {/* Title */}
      <h1
        className={cn(
          "text-3xl sm:text-6xl md:text-8xl font-bold mb-2 sm:mb-6",
          "font-sans",
          titleClassName || "text-brand-secondary"
        )}
      >
        {title}
      </h1>

      {/* Subtitle */}
      <p
        className={cn(
          "text-base sm:text-xl md:text-2xl max-w-2xl mx-auto px-4",
          subtitleClassName || "text-text-primary"
        )}
      >
        {subtitle}
      </p>
    </div>
  );
}

// Backwards compatibility export
export { HeroSection as PreLaunchContent };
